import { useState } from "react";
import * as yup from "yup";
import { Form, Button, Row, Col, Alert, message } from "antd";
import { useFormikContext, Formik } from "formik";
import { get, isEmpty } from "lodash";

import TextInput from "grandus-lib/components-atomic/form/TextInput";

const Feedback = ({ status, message }) => {
  if (message && status) {
    return (
      <Alert message="Úspešné" description={message} type={status} showIcon />
    );
  }
  return null;
};

const ForgottenPassword = () => {
  const [validateStatus, setValidateStatus] = useState("");
  const [message, setMessage] = useState();

  const formProps = {
    enableReinitialize: true,
    initialValues: {
      email: "",
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .nullable()
        .email("Zadajte email vo formáte name@domain.com")
        .required("Zadajte vašu emailovú adresu"),
    }),
    onSubmit: async (values, { setFieldError, setErrors, resetForm }) => {
      const { email } = values;
      const reqBody = { user: { email: email } };
      try {
        setMessage(null);
        setValidateStatus(null);
        const response = await fetch(`/api/lib/v1/auth/forgotten-password`, {
          method: "POST",
          body: JSON.stringify(reqBody),
        }).then((data) => data.json());

        if (response) {
          const errorMessage = get(get(response, "messages.0"), "message");
          if (!errorMessage) {
            resetForm();
            setValidateStatus("success");
            setMessage(
              "Na vašu emailovú adresu bol odoslaný link na zmenu hesla"
            );
          } else {
            setFieldError("email", errorMessage);
          }
        }
      } catch (error) {
        console.error("An unexpected error happened:", error);
        setErrors(error.data.message);
      }

      return false;
    },
  };

  return (
    <Formik {...formProps}>
      <ForgottenPasswordForm
        feedback={<Feedback status={validateStatus} message={message} />}
      />
    </Formik>
  );
};

const ForgottenPasswordForm = ({ feedback }) => {
  const {
    values,
    errors,
    touched,
    isSubmitting,
    isValid,
    dirty,
    handleChange,
    handleBlur,
    handleSubmit,
  } = useFormikContext();
  return (
    <Form wrapperCol={{ span: 24 }} layout="horizontal" onFinish={handleSubmit}>
      {!isEmpty(feedback) ? (
        <Row gutter={[20, 20]}>
          <Col xs={24}>{feedback}</Col>
        </Row>
      ) : null}
      <Row gutter={16}>
        <Col cs={24} md={20}>
          <TextInput
            label="Email"
            name="email"
            values={values}
            touched={touched}
            errors={errors}
            handleChange={handleChange}
            handleBlur={handleBlur}
          />
        </Col>

        <Col cs={24} md={4}>
          <Form.Item>
            <Button
              type="primary"
              htmlType="submit"
              loading={isValid && isSubmitting}
              disabled={!dirty || !isValid}
            >
              Odoslať
            </Button>
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};

export default ForgottenPassword;
